import clsx from "clsx";

import { Dropdown } from "@components/v2/inputs/select/dropdown";
import { OptionItem } from "@components/v2/inputs/select/option-item";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import { useFeatureFlags } from "@hooks/http";

interface Props {
  value: "blended" | "new" | "returning";
  onChange: (value: "blended" | "new" | "returning") => void;
}

export const MetricModeSelect = ({ value, onChange }: Props) => {
  const { hasFeatureFlag } = useFeatureFlags();

  return (
    <Listbox
      value={value}
      onChange={(val) => {
        onChange(val);
      }}
    >
      <ListboxButton
        className={clsx(
          "group font-semibold inline-flex items-center gap-1",
          "hover:text-v2-action data-[open]:text-v2-action",
        )}
      >
        <span className="underline">{value}</span>
        <i
          className={clsx(
            "fa-regular fa-angle-down text-base",
            "group-data-[open]:text-v2-action group-data-[open]:rotate-180",
            "transition-[transform] duration-200 ease-out",
          )}
        />
      </ListboxButton>
      <ListboxOptions
        as={Dropdown}
        anchor={{ to: "bottom start", gap: 4 }}
        transition
        className={clsx("w-28", {
          "bg-white": !hasFeatureFlag("enableDashboardV2"),
        })}
      >
        {["blended", "new", "returning"].map((option) => {
          return (
            <ListboxOption
              as={OptionItem}
              key={option}
              size={"sm"}
              value={option}
              option={{ label: option, value: option }}
              disabled={false}
              className="static"
            />
          );
        })}
      </ListboxOptions>
    </Listbox>
  );
};
